// extracted by mini-css-extract-plugin
export default {"label":"Label__label--2Si","readOnly":"Label__readOnly--2wz","hint":"Label__hint--2OC","fieldLabelAsterisk":"Label__fieldLabelAsterisk--1Vm","tooltipIcon":"Label__tooltipIcon--6RI"};